module.exports = require("@babel/runtime-corejs3/core-js/get-iterator");